/*jshint esversion: 11 */
import React, { useState, useEffect } from 'react';
import {
  Row,
  Col,
  Card,
  CardBody,
  Container,
  Table,
  Label,
  FormGroup,
  Button,
  Badge,
  Input
} from 'reactstrap';
import Breadcrumbs from '../../components/Common/Breadcrumb';
import PageDataLoader from '../Utility/PageDataLoader';
import Paginator from '../Utility/Paginator';
import {
  bulkPublishCircular,
  getCircularInfo,
  getCircularList,
  publishCircular
} from '../../api/circular';
import moment from 'moment';
import { validatePermissionKey } from '../../helpers/permission';
import {
  CREATE_CIRCULAR,
  DELETE_CIRCULAR,
  PUBLISH_CIRCULAR,
  UPDATE_CIRCULAR,
  VIEW_CIRCULAR
} from '../Utility/PermissionKeys';
import validator from 'validator';
import { stringify as QStringify, parse as QParse } from 'qs';
import { useHistory, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import ViewCircularModal from './ViewCircularModal';
import EditCircularModal from './EditCircularModal';
import DeleteCircularModal from './DeleteCircularModal';
import CreateCircularModal from './CreateCircularModal';
import SweetAlert from 'react-bootstrap-sweetalert';
import FilterCircularModal from './FilterCircularModal';
import PublishCircularModal from './PublishCircularModal';

function CircularListPage({ authUser }) {
  const history = useHistory();
  const [filterError, setFilterError] = useState(false);
  const [breadcrumbItems] = useState([
    { title: 'Circulars', link: '#' },
    { title: 'View List', link: '#' }
  ]);
  const [circularListLoading, setCircularListLoading] = useState(true);
  const [circularList, setCircularList] = useState([]);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    pageLimit: 10,
    totalEntries: 0,
    totalPages: 0
  });
  const [addCircularModalOpen, setAddCircularModalOpen] = useState(false);
  const [circularInfo, setCircularInfo] = useState({});
  const [circularInfoLoading, setCircularInfoLoading] = useState(false);
  const [circularInfoModalOpen, setCircularInfoModalOpen] = useState(false);
  const [updateCircularModalOpen, setUpdateCircularModalOpen] = useState(false);
  const [sortingRule, setSortingRule] = useState('createdAt$desc');
  const [filterModalOpen, setFilterModalOpen] = useState(false);
  const [currentFilterCount, setCurrentFilterCount] = useState(0);
  const [createdAtFilter, setCreatedAtFilter] = useState({
    startDate: null,
    endDate: null
  });
  const [updatedAtFilter, setUpdatedAtFilter] = useState({
    startDate: null,
    endDate: null
  });
  const [filterCircularName, setFilterCircularName] = useState('');
  const [filterType, setFilterType] = useState('');
  const [selectedTag, setSelectedTag] = useState(null);
  const [selectedBatches, setSelectedBatches] = useState([]);
  const [deleteCircularModalOpen, setDeleteCircularModalOpen] = useState(false);
  const [publishCircularModalOpen, setPublishCircularModalOpen] =
    useState(false);
  const [bulkPublishing, setBulkPublishing] = useState(false);
  const [publishModalOpen, setPublishModalOpen] = useState(false);
  const [publishMode, setPublishMode] = useState('bulk');
  const [singlePublishId, setSinglePublishId] = useState(null);

  const [selectedRows, setSelectedRows] = useState([]);
  const [deleteData, setDeleteData] = useState(null);
  const [isDeleted, setIsDeleted] = useState(false);

  const [successAlert, setSuccessAlert] = useState(false);
  const [requestError, setRequestError] = useState({
    show_alert: false,
    message: ''
  });

  function showErrorAlert(message) {
    setRequestError({ message, show_alert: true });
  }

  function resetErrorAlert() {
    setRequestError({ message: '', show_alert: false });
  }

  let listElem = document.getElementById('circularList');
  let linkElem = document.getElementById('circularLink');

  useEffect(() => {
    if (listElem) listElem.classList.add('mm-active');
    if (linkElem) linkElem.classList.add('active');
    if (authUser) {
      populateSearchOptions(history?.location?.search);
    }
    // eslint-disable-next-line
  }, [authUser, listElem, linkElem]);

  const handlePagination = async (page) => {
    await fetchData(
      page,
      pagination.pageLimit,
      createQueryOptions(),
      sortingRule
    );
  };

  const fetchData = async (
    current_page = 1,
    page_limit = 10,
    queryOptions = {},
    sortingOption = sortingRule
  ) => {
    setCircularListLoading(true);

    const response = await getCircularList(
      current_page,
      page_limit,
      queryOptions,
      sortingOption
    );

    if (response) {
      setPagination({
        currentPage: response.metadata.page,
        pageLimit: response.metadata.limit,
        totalPages: response.metadata.total_pages,
        totalEntries: response.metadata.total_results
      });
      setCircularList(response.data);
      setCircularListLoading(false);
    }
  };

  function getValidDateInput(str) {
    return validator.isDate(str) ? new Date(str).toISOString() : '';
  }

  function createQueryOptions(
    createdStart = createdAtFilter.startDate,
    createdEnd = createdAtFilter.endDate,
    updatedStart = updatedAtFilter.startDate,
    updatedEnd = updatedAtFilter.endDate,
    name = filterCircularName,
    type = filterType,
    deletedStatus = isDeleted
  ) {
    setFilterError(false);
    if (
      (!createdStart && createdEnd) ||
      (createdStart && !createdEnd) ||
      (!updatedStart && updatedEnd) ||
      (updatedStart && !updatedEnd)
    ) {
      setFilterError('Enter valid date range');
      return;
    }

    const startDateISOStringCreatedAt = getValidDateInput(createdStart);
    const endDateISOStringCreatedAt = getValidDateInput(createdEnd);
    const startDateISOStringUpdatedAt = getValidDateInput(updatedStart);
    const endDateISOStringUpdatedAt = getValidDateInput(updatedEnd);

    const queryOptions = {
      filter_start_created_at: startDateISOStringCreatedAt,
      filter_end_created_at: endDateISOStringCreatedAt,
      filter_start_last_updated_at: startDateISOStringUpdatedAt,
      filter_end_last_updated_at: endDateISOStringUpdatedAt,
      name,
      type,
      include_deleted: deletedStatus,
      filter_tag: selectedTag?.value || '',
      filter_batch:
        selectedBatches.length > 0
          ? selectedBatches.map((b) => b.value)
          : undefined,
      sorting_option: sortingRule
    };

    return queryOptions;
  }

  const applyFilters = async () => {
    const options = createQueryOptions();
    if (!options) return;

    updateFilterCount(options);

    await fetchData(1, pagination.pageLimit, options, sortingRule);
  };

  const resetFilters = async () => {
    // reset states
    setSelectedTag(null);
    setSelectedBatches([]);
    setFilterCircularName('');
    setFilterType('');
    setCreatedAtFilter({ startDate: null, endDate: null });
    setUpdatedAtFilter({ startDate: null, endDate: null });
    setIsDeleted(false);

    // reset count
    setCurrentFilterCount(0);

    // fetch fresh data
    const options = createQueryOptions(null, null, null, null, '', '', false);

    await fetchData(1, pagination.pageLimit, options, sortingRule);
  };

  function updateFilterCount(option) {
    let count = 0;
    Object.keys(option).forEach((i) => {
      if (option[i]?.toString()?.trim()?.length > 0 && option[i] !== false) {
        count += 1;
      }
    });
    setCurrentFilterCount(count - 1);
  }

  async function populateSearchOptions(searchQuery) {
    const parsedQuery = QParse(searchQuery.substring(1));

    const sortingOption = parsedQuery.sorting_option || sortingRule;
    setSortingRule(sortingOption);

    await fetchData(1, null, parsedQuery, sortingOption);
  }

  async function fetchSortedList(sortingOption) {
    setSortingRule(sortingOption);

    const queryOptions = createQueryOptions();
    if (!queryOptions) return;

    queryOptions.sorting_option = sortingOption;

    await fetchData(1, null, queryOptions, sortingOption);
  }

  function openFilterModal() {
    setFilterModalOpen(true);
  }

  function closeFilterModal() {
    setFilterModalOpen(false);
  }

  function openAddCircularModal() {
    setAddCircularModalOpen(true);
  }

  function closeAddCircularModal() {
    setAddCircularModalOpen(false);
  }

  function openCircularInfoModal(circularId) {
    fetchCircularInfo(circularId);
    setCircularInfoModalOpen(true);
  }

  function closeCircularInfoModal() {
    setCircularInfoModalOpen(false);
  }

  async function openUpdateCircularModal(circularId) {
    fetchCircularInfo(circularId);
    setUpdateCircularModalOpen(true);
  }

  function closeUpdateCircularModal() {
    setUpdateCircularModalOpen(false);
  }

  function openPublishCircularModal(circularId) {
    fetchCircularInfo(circularId);
    setPublishCircularModalOpen(true);
  }

  function closePublishCiruclarModal() {
    setPublishCircularModalOpen(false);
  }

  function openDeleteCircularModal(id, type) {
    setDeleteData({ id, type });
    setDeleteCircularModalOpen(true);
  }

  function closeDeleteCircularModal() {
    setDeleteCircularModalOpen(false);
    setDeleteData(null);
  }

  async function fetchCircularInfo(circularId) {
    setCircularInfoLoading(true);
    const response = await getCircularInfo(circularId);
    if (response) {
      setCircularInfo(response?.response?.data);
      setCircularInfoLoading(false);
    }
  }

  const selectAllRows = () => {
    if (selectedRows.length === circularList.length) {
      setSelectedRows([]);
    } else {
      setSelectedRows(circularList.map((c) => c._id));
    }
  };

  const isAllSelected = () => {
    return (
      selectedRows.length > 0 && selectedRows.length === circularList.length
    );
  };

  const isRowSelected = (id) => {
    return selectedRows.includes(id);
  };

  const toggleRowSelection = (id) => {
    setSelectedRows((prev) => {
      if (prev.includes(id)) {
        return prev.filter((i) => i !== id);
      } else {
        return [...prev, id];
      }
    });
  };

  const handleConfirmPublish = async () => {
    try {
      setBulkPublishing(true);

      if (publishMode === 'single') {
        const res = await publishCircular(singlePublishId);

        if (res?.response?.success) {
          setSuccessAlert('Circular Published Successfully');
        } else {
          showErrorAlert('Failed to publish circular');
        }
      } else {
        const unpublished = circularList
          .filter((c) => selectedRows.includes(c._id) && c.draft)
          .map((c) => c._id);

        if (unpublished.length === 0) {
          showErrorAlert('No unpublished circulars selected');
          return;
        }

        const res = await bulkPublishCircular(unpublished);

        if (res?.response?.success) {
          setSuccessAlert('Circulars Published Successfully');
        } else {
          showErrorAlert('Failed to publish circular');
        }

        setSelectedRows([]);
      }

      await fetchData(
        pagination.currentPage,
        pagination.pageLimit,
        createQueryOptions(),
        sortingRule
      );
    } catch (e) {
      showErrorAlert('Failed to publish circular');
    } finally {
      setBulkPublishing(false);
      setPublishModalOpen(false);
      setSinglePublishId(null);
    }
  };

  if (
    authUser &&
    authUser.user_type === 'staff' &&
    !validatePermissionKey(authUser, VIEW_CIRCULAR)
  ) {
    return <Redirect to="/dashboard" />;
  }

  return (
    <React.Fragment>
      {successAlert && (
        <SweetAlert
          success
          title="Success"
          onConfirm={() => setSuccessAlert(false)}
        >
          {successAlert}
        </SweetAlert>
      )}

      {requestError.show_alert && (
        <SweetAlert error title="Error" onConfirm={resetErrorAlert}>
          {requestError.message}
        </SweetAlert>
      )}

      <FilterCircularModal
        modalOpenState={filterModalOpen}
        closeModalHandler={closeFilterModal}
        applyFilters={applyFilters}
        resetFilters={resetFilters}
        selectedTag={selectedTag}
        setSelectedTag={setSelectedTag}
        selectedBatches={selectedBatches}
        setSelectedBatches={setSelectedBatches}
        isDeleted={isDeleted}
        setIsDeleted={setIsDeleted}
        authUser={authUser}
      />

      <CreateCircularModal
        modalOpenState={addCircularModalOpen}
        closeModalHandler={closeAddCircularModal}
        fetchNewCircularList={async () => {
          let options = createQueryOptions();
          if (options) {
            await fetchData(1, null, options);
          }
        }}
        refreshList={fetchData}
        setSuccessAlert={setSuccessAlert}
        showErrorAlert={showErrorAlert}
        resetErrorAlert={resetErrorAlert}
      />

      <ViewCircularModal
        modalOpenState={circularInfoModalOpen}
        closeModalHandler={closeCircularInfoModal}
        circularInfoLoading={circularInfoLoading}
        circularInfo={circularInfo}
      />

      <EditCircularModal
        modalOpenState={updateCircularModalOpen}
        closeModalHandler={closeUpdateCircularModal}
        circularInfo={circularInfo}
        refreshList={fetchData}
        circularInfoLoading={circularInfoLoading}
        fetchNewCircularList={async () => {
          let options = createQueryOptions();
          if (options) {
            await fetchData(1, null, options);
          }
        }}
        setSuccessAlert={setSuccessAlert}
        showErrorAlert={showErrorAlert}
        resetErrorAlert={resetErrorAlert}
        requestError={requestError}
      />

      <DeleteCircularModal
        modalOpenState={deleteCircularModalOpen}
        closeModalHandler={closeDeleteCircularModal}
        circularId={deleteData?.id}
        type={deleteData?.type}
        fetchNewData={async () => {
          let options = createQueryOptions();
          if (options) {
            await fetchData(1, null, options);
          }
        }}
        setSuccessAlert={setSuccessAlert}
        showErrorAlert={showErrorAlert}
        resetErrorAlert={resetErrorAlert}
      />

      <PublishCircularModal
        modalOpenState={publishModalOpen}
        closeModalHandler={() => {
          setPublishModalOpen(false);
          setSinglePublishId(null);
        }}
        publishHandler={handleConfirmPublish}
        selectedCount={publishMode === 'single' ? 1 : selectedRows.length}
        loading={bulkPublishing}
      />

      {deleteData && (
        <DeleteCircularModal
          modalOpenState={deleteCircularModalOpen}
          closeModalHandler={closeDeleteCircularModal}
          circularId={deleteData?.id}
          type={deleteData?.type}
          fetchNewData={async () => {
            let options = createQueryOptions();
            if (options) {
              await fetchData(1, null, options);
            }
          }}
          setSuccessAlert={setSuccessAlert}
          showErrorAlert={showErrorAlert}
          resetErrorAlert={resetErrorAlert}
        />
      )}

      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title="View circulars"
            breadcrumbItems={breadcrumbItems}
          />
          <Row>
            <Col xs={12}>
              <Card>
                <CardBody>
                  <>
                    <Row className="mt-2">
                      <Col md="2">
                        <FormGroup>
                          <Col md="12">
                            <Label className="col-form-label">
                              Show Entries
                            </Label>
                            <select
                              className="form-control"
                              onChange={(e) => {
                                fetchData(
                                  1,
                                  e.target.value,
                                  createQueryOptions(),
                                  sortingRule
                                );
                                setPagination({
                                  ...pagination,
                                  pageLimit: e.target.value
                                });
                              }}
                              value={pagination.pageLimit}
                              disabled={circularInfoLoading}
                            >
                              <option value={10}>10</option>
                              <option value={25}>25</option>
                              <option value={50}>50</option>
                              <option value={100}>100</option>
                            </select>
                          </Col>
                        </FormGroup>
                      </Col>
                      <Col md="3">
                        <FormGroup>
                          <Label className="col-form-label">
                            Sort Circulars
                          </Label>
                          <select
                            className="form-control"
                            onChange={(e) => {
                              fetchSortedList(e.target.value);
                            }}
                            value={sortingRule}
                            disabled={circularListLoading}
                          >
                            <option value="createdAt$desc">
                              Create Time (Newest First)
                            </option>
                            <option value="createdAt$asc">
                              Create Time (Oldest First)
                            </option>
                            <option value="updatedAt$desc">
                              Update Time (Newest First)
                            </option>
                            <option value="updatedAt$asc">
                              Update Time (Oldest First)
                            </option>
                          </select>
                        </FormGroup>
                      </Col>
                      <Col className="d-flex justify-content-end align-items-center">
                        {selectedRows.length > 0 &&
                          validatePermissionKey(authUser, PUBLISH_CIRCULAR) && (
                            <Button
                              size="sm"
                              color="success"
                              className="mr-2"
                              onClick={() => {
                                setPublishMode('bulk');
                                setPublishModalOpen(true);
                              }}
                              disabled={bulkPublishing}
                            >
                              {bulkPublishing
                                ? 'Publishing...'
                                : `Publish Selected (${selectedRows.length})`}
                            </Button>
                          )}
                        <Button
                          size="sm"
                          color="primary"
                          className="waves-effect waves-light mr-3"
                          onClick={openFilterModal}
                        >
                          <i className="ri-filter-fill align-middle mr-2"></i>
                          <span>Filter Circular</span>
                          {currentFilterCount > 0 && (
                            <Badge color="light" pill className="ml-2">
                              {currentFilterCount}
                            </Badge>
                          )}
                        </Button>
                        {validatePermissionKey(authUser, CREATE_CIRCULAR) && (
                          <Button
                            size="sm"
                            color="success"
                            className="waves-effect waves-light"
                            onClick={openAddCircularModal}
                          >
                            <i className="ri-add-line align-middle mr-2"></i>
                            Add Circular
                          </Button>
                        )}
                      </Col>
                    </Row>

                    {circularListLoading ? (
                      <div className="text-center">
                        <PageDataLoader />
                      </div>
                    ) : (
                      <div className="table-rep-plugin">
                        <div
                          className="table-responsive mb-0"
                          data-pattern="priority-columns"
                        >
                          <Table
                            id="tech-companies-1"
                            striped
                            bordered
                            responsive
                          >
                            <thead>
                              <tr>
                                {validatePermissionKey(
                                  authUser,
                                  PUBLISH_CIRCULAR
                                ) && (
                                  <th>
                                    <FormGroup check className="mb-4">
                                      <Input
                                        type="checkbox"
                                        checked={isAllSelected()}
                                        onChange={selectAllRows}
                                      />
                                    </FormGroup>
                                  </th>
                                )}
                                <th>SL. No</th>
                                <th>Description</th>
                                <th>Batch</th>
                                <th>Tag</th>
                                <th>Created By</th>
                                <th>File count</th>
                                <th>Published Status</th>
                                <th>Created At</th>
                                <th>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {circularList?.length === 0 ? (
                                <tr>
                                  <td
                                    colSpan={
                                      validatePermissionKey(
                                        authUser,
                                        PUBLISH_CIRCULAR
                                      )
                                        ? 9
                                        : 8
                                    }
                                    className="text-center"
                                  >
                                    No Data Available
                                  </td>
                                </tr>
                              ) : (
                                circularList.map((item, index) => {
                                  const isSelected = isRowSelected(item._id);

                                  return (
                                    <tr key={item._id || index}>
                                      {validatePermissionKey(
                                        authUser,
                                        PUBLISH_CIRCULAR
                                      ) && (
                                        <td>
                                          <FormGroup check className="mb-4">
                                            <Input
                                              type="checkbox"
                                              checked={isSelected}
                                              onChange={() =>
                                                toggleRowSelection(item._id)
                                              }
                                            />
                                          </FormGroup>
                                        </td>
                                      )}

                                      <td>{index + 1}</td>
                                      <td>{item?.description}</td>
                                      <td>
                                        <Link to={`/batches`}>
                                          {item.batches?.length > 0
                                            ? item.batches.map((b, i) => (
                                                <span key={b._id || i}>
                                                  <span
                                                    style={{
                                                      color: b.color || '#000'
                                                    }}
                                                  >
                                                    {b.name}
                                                  </span>
                                                  {i !==
                                                    item.batches.length - 1 &&
                                                    ', '}
                                                </span>
                                              ))
                                            : '-'}
                                        </Link>
                                      </td>

                                      <td>{item.tag?.name || '-'}</td>

                                      <td>
                                        <Link to={`/batches`}>
                                          {`${item.uploaded_by?.name || ''} [${
                                            item.uploaded_by_model?.toUpperCase?.() ||
                                            ''
                                          }]`}
                                        </Link>
                                      </td>

                                      <td>{item.files?.length || 0}</td>

                                      <td>
                                        <Badge
                                          style={{
                                            fontWeight: 'bold',
                                            fontSize: '12px'
                                          }}
                                          color={
                                            !item.draft
                                              ? 'success'
                                              : 'secondary'
                                          }
                                        >
                                          {!item.draft
                                            ? 'Published'
                                            : 'Unpublished'}
                                        </Badge>
                                      </td>

                                      <td>
                                        {moment(item.createdAt).format(
                                          'DD-MM-YYYY'
                                        )}
                                      </td>

                                      <td>
                                        <Button
                                          size="sm"
                                          color="primary"
                                          className="waves-effect waves-light mr-2 mb-2"
                                          onClick={() =>
                                            openCircularInfoModal(item._id)
                                          }
                                        >
                                          <i className="fas fa-eye mr-2"></i>
                                          View
                                        </Button>

                                        {validatePermissionKey(
                                          authUser,
                                          UPDATE_CIRCULAR
                                        ) && (
                                          <Button
                                            size="sm"
                                            color="warning"
                                            className="waves-effect waves-light mr-2 mb-2"
                                            onClick={() =>
                                              openUpdateCircularModal(item._id)
                                            }
                                          >
                                            <i className="fas fa-edit mr-2"></i>
                                            Edit
                                          </Button>
                                        )}

                                        {validatePermissionKey(
                                          authUser,
                                          PUBLISH_CIRCULAR
                                        ) && (
                                          <Button
                                            size="sm"
                                            color={
                                              !item.draft
                                                ? 'secondary'
                                                : 'success'
                                            }
                                            className="mr-2 mb-2"
                                            onClick={() => {
                                              setPublishMode('single');
                                              setSinglePublishId(item._id);
                                              setPublishModalOpen(true);
                                            }}
                                            disabled={!item.draft}
                                          >
                                            <i className="fas fa-upload mr-2"></i>
                                            Publish
                                          </Button>
                                        )}

                                        {validatePermissionKey(
                                          authUser,
                                          DELETE_CIRCULAR
                                        ) && (
                                          <Button
                                            size="sm"
                                            color="danger"
                                            className="waves-effect waves-light mb-2"
                                            onClick={() =>
                                              openDeleteCircularModal(
                                                item._id,
                                                item.isDeleted
                                                  ? 'restore'
                                                  : 'delete'
                                              )
                                            }
                                          >
                                            {item.isDeleted ? (
                                              <i className="fas fa-trash-restore mr-2"></i>
                                            ) : (
                                              <i className="fas fa-trash mr-2"></i>
                                            )}
                                            {item.isDeleted
                                              ? 'Restore'
                                              : 'Delete'}
                                          </Button>
                                        )}
                                      </td>
                                    </tr>
                                  );
                                })
                              )}
                            </tbody>
                          </Table>
                        </div>
                      </div>
                    )}

                    <Row className="mt-2">
                      <Col md="5">
                        <p>
                          <strong>
                            Showing{' '}
                            {(pagination.currentPage - 1) *
                              pagination.pageLimit +
                              1}{' '}
                            to{' '}
                            {Math.min(
                              pagination.currentPage * pagination.pageLimit,
                              pagination.totalEntries
                            )}{' '}
                            of {pagination.totalEntries} entries
                          </strong>
                        </p>
                      </Col>
                      {!circularListLoading && circularList.length > 0 && (
                        <Col md="7">
                          <Paginator
                            totalPages={pagination.totalPages}
                            currentPage={pagination.currentPage}
                            changePage={handlePagination}
                          />
                        </Col>
                      )}
                    </Row>
                  </>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
}

const mapStateToProps = (state) => {
  return {
    authUser: state.Login?.user
  };
};

export default connect(mapStateToProps)(CircularListPage);
